import {RequestsRecord} from './common/interfaces/IHttpRequest';

export const AppRequests: RequestsRecord = {
  // backend status
  backendState: {
    url: '/_health',
    authType: 'hmac',
    method: 'GET',
    errorType: 'none',
    headers: [{ HealthCheck: 'Postman' }],
    cache: false,
  },
  // auth requests for register user
  authLogin: {
    url: '/account/getJwtToken',
    authType: 'hmac',
    method: 'POST',
    errorType: 'popup',
  },
  authRefreshToken: {
    url: '/Account/RefreshJwtToken',
    authType: 'hmac',
    method: 'POST',
    errorType: 'popup',
  },
  authRecoveryByPhone: {
    url: '/Account/RecoverPasswordByPhone',
    authType: 'hmac',
    method: 'POST',
    errorType: 'popup',
  },
  authConfirmRecoveryByPhone: {
    url: '/Account/ConfirmRecoveryPasswordByPhone',
    authType: 'hmac',
    method: 'POST',
    errorType: 'popup',
  },

  // user data
  usersGetCurrent: {
    url: '/Users/Current',
    authType: 'jwt',
    method: 'GET',
    errorType: 'popup',
  },
  userUploadAvatar: {
    url: '/Users/UploadAvatar',
    authType: 'jwt',
    method: 'POST',
    errorType: 'popup',
  },
  updateUserData: {
    url: '/Users',
    authType: 'jwt',
    method: 'PUT',
    errorType: 'popup',
  },

  // UserPaymentAccounts
  userPaymentAccounts: {
    url: '/Finance/Accounts',
    authType: 'jwt',
    method: 'GET',
    errorType: 'popup',
  },

  // User Notifications
  userNotifications: {
    url: '/Notifications',
    authType: 'jwt',
    method: 'GET',
    errorType: 'popup',
  },
  markNotificationAsRead: {
    url: '/Notifications/:param/MarkAsRead',
    authType: 'jwt',
    method: 'PATCH',
    errorType: 'popup',
  },
  markAllNotificationsAsRead: {
    url: '/Notifications/MarkAllAsRead',
    authType: 'jwt',
    method: 'PATCH',
    errorType: 'popup',
  },
  deleteAllNotifications: {
    url: '/Notifications/DeleteAll',
    authType: 'jwt',
    method: 'DELETE',
    errorType: 'popup',
  },

  // Settings

  getAllCountriesWithCities: {
    url: '/Settings/CountriesWithCities',
    authType: 'hmac',
    method: 'GET',
    errorType: 'popup',
    cache: false,
  },

  // Regional

  getCountries: {
    url: '/Settings/Countries',
    authType: 'hmac',
    method: 'GET',
    errorType: 'none',
  },

  getRegionsWithCities: {
    url: '/Settings/Country/:param/RegionsWithCities',
    authType: 'hmac',
    method: 'GET',
    errorType: 'none',
    cache: false,
  },

  getCountryCurrencies: {
    url: '/Settings/Country/:param/Currencies',
    authType: 'hmac',
    method: 'GET',
    errorType: 'none',
  },

  getCountryTaxTypes: {
    url: '/Settings/Country/:param/TaxTypes',
    authType: 'hmac',
    method: 'GET',
    errorType: 'none',
  },

  // Other

  getFeedbackSubjects: {
    url: '/Settings/FeedbackSubjects',
    authType: 'hmac',
    method: 'GET',
    errorType: 'popup',
  },
  getCommunicationMethods: {
    url: '/Settings/CommunicationMethods',
    authType: 'hmac',
    method: 'GET',
    errorType: 'popup',
  },

  // Feedback

  postFeedbackHmac: {
    url: '/Feedback',
    authType: 'hmac',
    method: 'POST',
    errorType: 'popup',
  },
  postFeedbackJwt: {
    url: '/Feedback',
    authType: 'jwt',
    method: 'POST',
    errorType: 'popup',
  },

  // Complaints

  getComplaints: {
    url: '/Users/Complaints',
    authType: 'jwt',
    method: 'GET',
    errorType: 'popup',
  },
  ignoreComplaint: {
    url: '/Users/Complaints/:param/Ignore',
    authType: 'jwt',
    method: 'PATCH',
    errorType: 'popup',
  },
};

export const orgRolesArr = [
  { value: 1, display: 'Администратор' },
  { value: 2, display: 'Менеджер' },
  { value: 3, display: 'Агент' },
];

export const apiWithoutTransferCache = [
  'PV/Vehicles/Popular',
  'PV/Vehicles/SpecialOffer',
  '_health',
];
